import { Window } from '../../ui/Window.js';
import { DASFForm } from "../../data/dasf/DASFForm.js";

import { DASFConnection } from '../../../lib/dasf/DASFConnection.js';

import { DASFModuleResponse, DASFModuleRequest, DASFModuleRequestReceipt } from '../../../lib/dasf/DASFMessages.js'

import { WebsocketUrlBuilder } from '../../../lib/dasf/DASFUrlBuilder.js'

import { responseHandlerRegistry } from '../../data/dasf/responseHandlerRegistry.js';

/**
 * A function that creates the DASF loader form
 * 
 * @memberof vef.viewer.loader
 * 
 * @param {object} options 
 * @param {Viewer} viewer 
 */
export function DASFLoader(options, viewer) {

    console.log(options.websocketUrl);
    const dasfConnection = new DASFConnection(new WebsocketUrlBuilder(options.websocketUrl, options.topic));

    const element = new DASFForm(null, {});

    element.on("invalid", e => console.log(e));
    element.on("submit", (data) => {

        const request = DASFModuleRequest.createRequestMessage();
        const plotWindow = new Window(null, {
            width: "500px",
            height: "unset",
            open: true,
            center: true,
            title: "Data Analytics Software Framework"
        });
        plotWindow.setContent("Request submitted...")
        request.payload = btoa(JSON.stringify(data));

        dasfConnection.sendRequest(
            request, 
            (response) => {

                var responseData;
                if (response.properties.status == "error") {
                    responseData = "Error: " + atob(response.payload)
                } else {
                    responseData = JSON.parse(atob(response.payload));
                }
                var responseHandler;
                if (responseData.response_type) {
                    responseHandler = responseHandlerRegistry[responseData.response_type];
                    responseHandler(responseData, plotWindow);
                } else {
                    responseHandler = responseHandlerRegistry.default;
                    responseHandler(responseData, plotWindow);
                }
        })
    });

    viewer.addElement(options.id, element);

    function waitForConnection() {
        if (dasfConnection.assureConnected()) {
            dasfConnection.sendRequest(
                DASFModuleRequest.createApiInfoMessage(),
                (response) => {
                    const api_info = JSON.parse(response.properties.api_info);
                    element.initForm(api_info.functions.map((info) => info.rpc_schema));
                }
            )
        } else {
            window.setTimeout(waitForConnection, 100);
        }
    }

    waitForConnection();

}